import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import React, { useCallback, useState } from 'react';
import { useMutation } from '@apollo/client';
import { DownloadArrowIcon } from '../../../../components';
import classes from './downloadsPopup.module.css';
import Downloads from './Downloads/downloads';
import { checkIfImageIsAvailable, generateDownloadUrlSuccess } from '../../../../hooks/utils';
import useToast from '../../../../hooks/useToast';
import { GENERATE_DOWNLOAD_URL } from '../../../../graphql/downloadImages/actions.gql';
import { useUserContext } from '@magento/peregrine/lib/context/user/';

var DownloadsPopup = function DownloadsPopup(_ref) {
  var installationSheetUrl = _ref.installationSheetUrl,
      product = _ref.product,
      _ref$isOutlet = _ref.isOutlet,
      isOutlet = _ref$isOutlet === void 0 ? false : _ref$isOutlet,
      _ref$familyCustomPdfs = _ref.familyCustomPdfs,
      familyCustomPdfs = _ref$familyCustomPdfs === void 0 ? false : _ref$familyCustomPdfs,
      _ref$isPdp = _ref.isPdp,
      isPdp = _ref$isPdp === void 0 ? false : _ref$isPdp,
      _ref$isUserSignedIn = _ref.isUserSignedIn,
      isUserSignedIn = _ref$isUserSignedIn === void 0 ? false : _ref$isUserSignedIn;

  var _useState = useState(isPdp),
      _useState2 = _slicedToArray(_useState, 2),
      isOpenPopup = _useState2[0],
      setIsOpenPopup = _useState2[1];

  var _useMutation = useMutation(GENERATE_DOWNLOAD_URL),
      _useMutation2 = _slicedToArray(_useMutation, 1),
      generateDownloadUrl = _useMutation2[0];

  var _useToast = useToast(),
      addMessage = _useToast.addMessage;

  var _useUserContext = useUserContext(),
      _useUserContext2 = _slicedToArray(_useUserContext, 1),
      isSignedIn = _useUserContext2[0].isSignedIn;

  var downloadImagesMethod = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var input,
          filteredRequest,
          _yield$generateDownlo,
          data,
          _args = arguments;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              input = _args.length > 0 && _args[0] !== undefined ? _args[0] : false;
              filteredRequest = input !== null && input !== void 0 && input.images ? checkIfImageIsAvailable(input) : [];

              if (filteredRequest.length) {
                _context.next = 4;
                break;
              }

              return _context.abrupt("return", addMessage('error', 'No images available for download'));

            case 4:
              _context.next = 6;
              return generateDownloadUrl({
                variables: {
                  input: filteredRequest
                }
              });

            case 6:
              _yield$generateDownlo = _context.sent;
              data = _yield$generateDownlo.data;

              try {
                generateDownloadUrlSuccess(data);
              } catch (error) {
                addMessage('error', 'Error downloading image');
              }

            case 9:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function downloadImagesMethod() {
      return _ref2.apply(this, arguments);
    };
  }();

  var handleDownloadImage = function handleDownloadImage() {
    var _product$media_galler;

    var obj = {};
    obj['product_sku'] = product === null || product === void 0 ? void 0 : product.sku;
    obj['images'] = product === null || product === void 0 ? void 0 : (_product$media_galler = product.media_gallery) === null || _product$media_galler === void 0 ? void 0 : _product$media_galler.reduce(function (acc, curr) {
      return [].concat(_toConsumableArray(acc), [{
        url: curr.url
      }]);
    }, []);
    return downloadImagesMethod(obj);
  };

  var handleOpen = useCallback(function () {
    return setIsOpenPopup(function (prevState) {
      return !prevState;
    });
  });
  return React.createElement("div", {
    className: classes.downloadBtn,
    onClick: handleOpen
  }, React.createElement("div", {
    className: "".concat(classes.downloadList, " ").concat(isPdp && classes.pdpDownloads, " ").concat(isOutlet && classes.downloadOutlet),
    style: {
      display: isOpenPopup || isPdp ? 'block' : 'none'
    }
  }, React.createElement(Downloads, {
    installationSheetUrl: installationSheetUrl,
    classes: {
      downloadBtn: classes.downloadBtn,
      downloadBtnWrapper: 'flex items-center',
      downloadLink: !isSignedIn ? classes.cursorLink : ''
    },
    icon: React.createElement("div", {
      className: "mr-2"
    }, React.createElement(DownloadArrowIcon, null)),
    isOutlet: isOutlet,
    familyCustomPdfs: familyCustomPdfs,
    product: product,
    isPdp: isPdp
  }), isSignedIn && !familyCustomPdfs && React.createElement("div", {
    onClick: handleDownloadImage,
    className: "cursor-pointer flex items-center flex"
  }, React.createElement(DownloadArrowIcon, null), " ", React.createElement("span", {
    className: "ml-2 font-bold"
  }, "Images"))), !isPdp ? React.createElement(React.Fragment, null, React.createElement(DownloadArrowIcon, null), ' ', React.createElement("span", {
    className: "ml-2 font-bold underline text-bronze"
  }, "".concat(familyCustomPdfs ? 'Custom Versions' : 'Downloads'))) : React.createElement(React.Fragment, null));
};

export default DownloadsPopup;